module.exports = __webpack_public_path__ + "img/05.739f7ba5.png";